import { Header, Footer, Title, PageHeader } from '../components/shared'
import { CertCard } from '../components/certificate'
import { gql } from '@apollo/client'
import { createServerApolloClient } from '../dsl/client'
import { mapValues, keyBy } from 'lodash'
import { StaticDataProvider } from '../hooks/staticData'

const pagehead = {
    title: 'گواهی نامه ها',
    img_path: '/media/img/fname/hero-certificates-1920-448.jpg',
    breadcrumbs: [
        {
            id: '1',
            name: 'خانه'
        },
        {
            id: '2',
            name: 'گواهی نامه ها'
        }
    ]
}

const cert = [
    {
        title: 'گواهی نامه فنی وزارت راه و شهرسازی',
        subtitle: 'مرکز تحقیقات ساختمان و مسکن',
        img_path: '/media/img/fname/گواهینامه-وزارت-1088-755.jpg'
    },
    {
        title: 'گواهی نامه صنف ساختمان',
        subtitle: 'اولین همایش توسعه دهندگان پروژه های مسکن و ساختمان ایران',
        img_path: '/media/img/fname/گواهینامه-صنف-1088-755.jpg'
    }
]

export default function Certificates({
    pageHeader = pagehead,
    certificates = cert,
    staticData = {}
}) {
    let breadcrumbItems = []
    pageHeader.breadcrumbs.map((breadcrumb) =>
        breadcrumbItems.push(breadcrumb.name)
    )
    return (
        <StaticDataProvider data={staticData}>
            <div dir="rtl">
                <Header />
                <PageHeader
                    title={pageHeader.title}
                    img_path={pageHeader.img_path}
                    breadcrumb={breadcrumbItems}
                />
                <section className="relative">
                    <div className="px-4 lg:px-28 2xl:px-60 pb-10 2xl:text-base">
                        <Title>گواهی نامه های فنی باریستا</Title>
                        <p className="text-gray-silver">
                            گروه صنعتی باریستا پیشتازدر زمینه طراحی مهندسی و
                            ساخت صنعتی انواع سازه های فلزی در ایران است. این
                            مجموعه با بکارگیری از فناوری روز جهان و تکیه بر
                            نیروی انسانی متخصص و مجرب ایرانی توانسته است طیف
                            گسترده ای ار تولید صنعتی اسکلت های فولادی را ارایه
                            نماید.
                        </p>
                    </div>
                    <div className="grid lg:grid-cols-2 bg-gray-cultured gap-16 lg:gap-10 py-20 px-4 lg:px-28 2xl:px-60">
                        {certificates.map((certificate, idx) => (
                            <CertCard
                                key={idx}
                                title={certificate.title}
                                subtitle={certificate.subtitle}
                                img_path={certificate.img_path}
                            />
                        ))}
                    </div>
                </section>
                <Footer />
            </div>
        </StaticDataProvider>
    )
}

export async function getStaticProps() {
    const footerQuery = gql`
        query ($keys: [String]) {
            staticData: documents(
                search: {
                    type: { values: ["setting"], type: EXACT }
                    name: { values: $keys, type: EXACT }
                }
            ) {
                entities {
                    name
                    content
                    metas
                }
            }
        }
    `
    const client = createServerApolloClient()
    const settingKeys = [
        'about_footer',
        'email',
        'work_time',
        'head_tel',
        'tel',
        'addr',
        'head_sub',
        'head_sub',
        'about_home',
        'resume',
        'catalog'
    ]
    const { data } = await client.query({
        query: footerQuery,
        variables: { keys: settingKeys }
    })
    const staticData = mapValues(
        keyBy(data?.staticData?.entities, 'name'),
        (i) => i
    )

    return {
        props: {
            staticData
        },
        revalidate: 60
    }
}
